/** @jsx jsx */
import { jsx, Container } from 'theme-ui';

import Layout from 'components/layout';
import SEO from 'components/seo';

const TermsPage = () => (
  <Layout>
    <SEO title="Terms of Service" />
    <section sx={styles.section}>
      <Container sx={styles.containerBox}>

        <h2>PRINCIPAL Software (W.L.L.) TERMS OF USE</h2>
        <small>
          <i> Last Updated: 21 Sep. 2018 </i>
        </small>

        <p>
          These terms of use ("Terms") apply to your access and use of PRINCIPAL Software (W.L.L.) (the "Website"). We reserve the
          right to modify these Terms at any time. For instance, we may need to change these Terms if we come
          out with a new feature or for some other reason. Whenever we make changes to these Terms, the changes
          are effective two days after we post such revised Terms (indicated by revising the date at the top
          of these Terms) or upon your acceptance if we provide a mechanism for your immediate acceptance of
          the revised Terms (such as a click-through confirmation or acceptance button). It is your responsibility
          to check PRINCIPAL Software (W.L.L.) for changes to these Terms. Please read them carefully.
        </p>
        <ul>
          <li id="TopPage">
            <a href="#Term1"> Acceptance of Terms of Use </a>
          </li>
          <li>
            <a href="#Term2"> Users' Obligations </a>
          </li>
          <li>
            <a href="#Term3"> Description of Services </a>
          </li>
          <li>
            <a href="#Term35"> Change of Service and Termination </a>
          </li>
          <li>
            <a href="#Term4"> Use of the Services by You </a>
          </li>
          <li>
            <a href="#Term5"> Creating Accounts </a>
          </li>
          <li>
            <a href="#Term6"> Feedback </a>
          </li>
          <li>
            <a href="#Term7"> Questions &amp; Contact Information </a>
          </li>
        </ul>

        <br />
        <h4 id="Term1">
          Acceptance of Terms of Use
        </h4>
        <p>
          Principal Software (W.L.L) owns the trademark "PRINCIPAL Software (W.L.L.)" and operates a web hosted service under this
          trademark name. This Terms of Use Agreement is a legal agreement between you, either an individual
          or an entity you legally represent, and Principal Software (W.L.L), If you access or use "PRINCIPAL
          Software (W.L.L.)" Website, it means you agree to be bound by all of the terms below. So, before you
          use the Website read all of the terms, all information, graphics, documents, text, products and all
          other elements of the Website and all products offered on this Website and services operated through
          the Website, available for your use subject to the terms and conditions set forth in this document.
          By accessing and using this Website.
        </p>
        <p>
          If you don't agree to all of the terms below, please do not use the Service. Also, if you don't agree to any additional specific
          terms which apply to particular Content or to particular transactions concluded through this Website,
          then you should not use the part of the Website which contains such Content or through which such transactions
          may be concluded and you should not use such Content or conclude such transactions. if you continue
          to use the Service after the revised Terms go into effect, then you have accepted the changes to these
          Terms.
        </p>

        <br />
        <h4 id="Term2">
          Users' Obligations
        </h4>

        <p>
          You agree to use the Website, PRINCIPAL Software (W.L.L.), and Services only for purposes permitted by these Terms of Use
          as well as any applicable law, regulation or generally accepted practices or guidelines in the relevant
          jurisdictions.
          <b>
            Principal Software (W.L.L) is not responsible for any violation of applicable laws, rules, or regulations committed by you
            or a third party at your behest. it is your responsibility to ensure that your use of the website,
            PRINCIPAL Software (W.L.L.), and services does not contravene applicable laws, rules, or regulations.
          </b>
          Specifically, you agree and warrant that in using the Website and Services, your actions do not contravene the laws, rules,
          or regulations of (1) the country, state, or locality where you reside, or (2) the country, state,
          or locality where PRINCIPAL Software (W.L.L.) is located or operates. This includes complying with
          applicable export and import restrictions as well as other restrictions.
        </p>

        <br />
        <h4 id="Term3">
          Description of Services
        </h4>
        <p>
          PRINCIPAL Software (W.L.L.), is an online Enterprise Resource Planning (ERP) software, that offers free and paid services.
          The service enables you to follow up the employees within the company, process of requests for leave,
          the possibility of employee evaluation and follow-up performance, Identify competencies by employees
          and by job, Collect the Curriculum Vitae (CV) from applicants for jobs. PRINCIPAL Software (W.L.L.)
          offers other online financial, and Process management applications.
        </p>

        <br />
        <h4 id="Term3.5">
          Change of Service and Termination
        </h4>
        <p>
          Principal Software (W.L.L.) reserves the right to change the service features, either by adding new features or removing
          them. It also reserves the right to terminate the service after giving the existing subscribers 30
          days notice. You agree on using the service as is, Principal Software (W.L.L) provides no warranty
          for the level of Service or the offered features. If the Service does not satisfy you needs, or does
          not work as expected, you have the right to end your subscription at any time, with no further liabilities
          Principal Software (W.L.L.) behalf.
        </p>

        <br />
        <h4 id="Term4">
          Use of the Services by You
        </h4>
        <p>
          You agree to use the Services only for purposes permitted by these Terms of Use as well as any applicable law, regulation
          or generally accepted practices . You agree not to access (or attempt to access) any of the Services
          by any means other than through the means that is provided by PRINCIPAL Software (W.L.L.). You agree
          not to access or attempt to access any of the Services by way of automated means and that you will
          not engage in any activity that interferes with or disrupts the Services, (1) not to disrupt or interfere
          with any other user's, (2) not to upload, post, or otherwise transmit through the Website or the Services
          any viruses or other harmful, disruptive, or destructive files, (3) not to use or attempt to use another
          user's User Account, password, or system, (4) not to access or attempt to access any Content or User
          Content (as defined below), which you are not authorized to access under the terms herein, (5) not
          to disrupt or interfere with the security of, or otherwise cause harm to, the Website, Services, Content,
          User Content, system resources, accounts, passwords, servers, or networks connected to or accessible
          through this Website or any affiliated or linked sites. You have the right to end your subscription
          at any time. By ending your subscription you agree that, all your generated data and account information
          will be permanently deleted.
        </p>

        <br />
        <h4 id="Term5">
          Creating Accounts
        </h4>
        <p>
          When you create an account or use another service to log in to the Service, you agree to maintain the security of your password
          and accept all risks of unauthorized access to any data or other information you provide to the Service.
          If you discover or suspect any Service security breaches, please let us know as soon as possible.
        </p>

        <br />
        <h4 id="Term6">
          Feedback
        </h4>
        <p>
          Please let us know what you think of the Service, these Terms and, in general, PRINCIPAL Software (W.L.L.). When you provide
          us with any feedback, comments or suggestions about the Service, these Terms and, in general, PRINCIPAL
          Software (W.L.L.), you irrevocably assign to us all of your right, title and interest in and to your
          feedback, comments and suggestions.
        </p>

        <br />
        <h4 id="Term7">
          Questions &amp; Contact Information
        </h4>
        <p>
          Questions or comments about the Service may be directed to us at the email address support@principal.software .
        </p>
      </Container>
    </section>
  </Layout>
);

const styles = {
  section: {
    pt: 10,
    pb: 3,
    position: 'relative',
    zIndex: 2,
  },
  containerBox: {
    display: 'flex',
    flexDirection: 'column',
    pb: [0, null, null, null, null, 7],
  },

};

export default TermsPage;
